import { getPermissions, hasPermission } from "../../utilis/permissionStorage";
import React, { useEffect, useState } from "react";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import BackButton from "../base/BackButton";
import CustomLink from "../base/CustomLink";
import ReactPaginate from "react-paginate";
import Button from "../base/Button";
import Swal from "sweetalert2";

function ChecklistToProviders() {
  const [permissions, setPermissions] = useState([]);
  const [showSkeleton, setShowSkeleton] = useState(true);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    total: 0,
    lastPage: 1,
  });
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedProviderId, setSelectedProviderId] = useState(null);
  const [selectedCourseId, setSelectedCourseId] = useState("");

  const [providerSearch, setProviderSearch] = useState("");
  const [courseSearch, setCourseSearch] = useState("");
  const [checklistSearch, setChecklistSearch] = useState("");

  const [isProviderOpen, setIsProviderOpen] = useState(false);
  const [isCourseOpen, setIsCourseOpen] = useState(false);
  const [isCehckListOpen, setIsCheckListOpen] = useState(false);

  const [providersList, setProvidersList] = useState([]);
  const [coursesList, setCoursesList] = useState([]);

  const [allCheckListCategories, setAllCheckListCategories] = useState([]);
  const [selectedChecklistCategory, setSelectedChecklistCategory] =
    useState("");
  const [filterKey, setFilterKey] = useState(0);

  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    const pers = getPermissions();
    if (pers) setPermissions(pers);
  }, []);

  const handlePerPageChange = (e) => {
    setSelectedRows([]);
    setPagination((prev) => ({
      ...prev,
      perPage: parseInt(e.target.value),
      currentPage: 1,
    }));
  };

  const handlePageChange = (selectedItem) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: selectedItem.selected + 1,
    }));
  };

  const fetchData = async () => {
    setShowSkeleton(true);
    try {
      const response = await apiUrl.get("/provider-checklist-assignment", {
        params: {
          page: pagination.currentPage,
          perPage: pagination.perPage,
          checklist_category_id: selectedChecklistCategory || undefined,
          provider_id: selectedProviderId || undefined,
          course_id: selectedCourseId || undefined,
        },
      });
      if (response?.data) {
        setPagination((prev) => ({
          ...prev,
          total: response?.data?.pagination.total,
          lastPage: response?.data?.pagination.lastPage,
          currentPage: response?.data?.pagination.currentPage,
        }));
        setList(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setShowSkeleton(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.currentPage, pagination.perPage, filterKey]);

  // fetch categories
  useEffect(() => {
    fetchCategories();
  }, []);
  const fetchCategories = async () => {
    try {
      const response = await apiUrl.get("/prechecklistCategory");
      if (response?.data?.status) {
        setCategories(response?.data?.data || []);
      }
    } catch (error) {
      console.error(error);
    }
  };
  // fetch providers when category select
  const getProvidersByNames = async () => {
    if (!selectedCategory) {
      setProvidersList([]);
      return;
    }
    try {
      const response = await apiUrl(`/getProvidersByNames/${selectedCategory}`);
      if (response?.data?.status) {
        setProvidersList(
          Array.isArray(response?.data?.data) ? response?.data?.data : []
        );
      }
    } catch (error) {
      setProvidersList([]);
      console.error(error);
    }
  };

  useEffect(() => {
    getProvidersByNames();
  }, [selectedCategory]);

  // fetch courses
  const fetchCourses = async () => {
    if (!selectedProviderId) {
      setCoursesList([]);
      setSelectedCourseId("");
      return;
    }
    try {
      const response = await apiUrl.get(
        `/getCourseByNames/${selectedProviderId}`
      );
      if (response?.data?.status) {
        setCoursesList(
          Array.isArray(response?.data?.data) ? response?.data?.data : []
        );
      } else {
        setCoursesList([]);
      }
    } catch (error) {
      console.error(error);
      setCoursesList([]);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, [selectedProviderId]);

  // fetch checklist categories
  const fetchAllCheckListCategories = async () => {
    try {
      const response = await apiUrl("/getAllCheckListCategory");
      if (response?.status === 200) {
        setAllCheckListCategories(response.data.data);
      } else {
        setAllCheckListCategories([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllCheckListCategories();
  }, []);

  const filteredProviders = React.useMemo(() => {
    if (!providerSearch.trim()) return providersList;
    return providersList.filter((provider) =>
      provider.name.toLowerCase().includes(providerSearch.toLowerCase())
    );
  }, [providersList, providerSearch]);

  const filteredCourses = React.useMemo(() => {
    if (!courseSearch.trim()) return coursesList;
    return coursesList.filter((course) =>
      course.name.toLowerCase().includes(courseSearch.toLowerCase())
    );
  }, [coursesList, courseSearch]);

  const filteredChecklistCategories = React.useMemo(() => {
    if (!checklistSearch.trim()) return allCheckListCategories;
    return allCheckListCategories.filter((item) =>
      item.name.toLowerCase().includes(checklistSearch.toLowerCase())
    );
  }, [allCheckListCategories, checklistSearch]);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".provider-dropdown")) {
        setIsProviderOpen(false);
      }
      if (!event.target.closest(".course-dropdown")) {
        setIsCourseOpen(false);
      }
      if (!event.target.closest(".checklist-dropdown")) {
        setIsCheckListOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  const handleDelete = async (id, name) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await apiUrl.delete(
            `/provider-checklist-assignment/${id}`
          );
          if (response?.data?.status) {
            Swal.fire({
              title: response.data.message,
              icon: "success",
              timer: 3000,
              toast: true,
              showConfirmButton: false,
              position: "top-end",
            });
            fetchData();
            setLoading(false);
          }
        } catch (error) {
          Swal.fire({
            title: error.response?.data?.message || "Error deleting department",
            icon: "error",
            timer: 3000,
            toast: true,
            showConfirmButton: false,
            position: "top-end",
          });
        }
      }
    });
  };
  const handleDeleteBulk = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await apiUrl.post(
            `/bulk-provider-checklist-delete`,
            {
              selectedRows,
            }
          );
          if (response?.data?.status) {
            Swal.fire({
              title: response.data.message,
              icon: "success",
              timer: 3000,
              toast: true,
              showConfirmButton: false,
              position: "top-end",
            });
            fetchData();
            setLoading(false);
            setSelectedRows([]);
          }
        } catch (error) {
          Swal.fire({
            title: error.response?.data?.message || "Error deleting department",
            icon: "error",
            timer: 3000,
            toast: true,
            showConfirmButton: false,
            position: "top-end",
          });
        }
      }
    });
  };
  return (
    <>
      {permissions?.manage_checklist && (
        <div className="card px-4 py-3 bg-white">
          {/* Header */}
          <header className="mb-3">
            <div className="flex align-center justify-between flex-wrap">
              <div className="flex align-center gap-3">
                <BackButton url="/checklist" />
              </div>
              <CustomLink
                to="/checklist/attach/to-provider"
                size="sm"
                variant="outline"
              >
                CheckList Attach to Providers
              </CustomLink>
            </div>
          </header>
          {/* search filter */}
          <div className="flex items-center justify-between mb-2">
            <h1 className="h4 font-semibold">
              CheckLists Attached to Providers
            </h1>
          </div>
          {/* filters */}
          <div className="mb-6 bg-gray-50 rounded-lg border border-gray-200 p-4">
            {/* Filter Row */}
            <div className="flex flex-wrap gap-4 mb-3">
              {/* Category */}
              <div className="flex-1 min-w-[180px]">
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  Category
                </label>
                <select
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                  className="w-full text-sm py-2 px-3 border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none bg-white"
                >
                  <option value="">— Select —</option>
                  {categories?.category?.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Provider Dropdown */}
              <div className="flex-1 min-w-[180px] relative provider-dropdown">
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  Provider
                </label>
                <div
                  className="w-full text-sm py-2 px-3 border border-gray-300 rounded-md cursor-pointer bg-white focus-within:ring-1 focus-within:ring-blue-500"
                  onClick={() => setIsProviderOpen(!isProviderOpen)}
                >
                  <span className="truncate text-gray-800 block overflow-hidden text-ellipsis">
                    {selectedProviderId
                      ? providersList.find((p) => p.id == selectedProviderId)
                          ?.name || "— Select —"
                      : "— Select —"}
                  </span>
                </div>

                {isProviderOpen && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
                    <div className="p-2 border-b">
                      <input
                        type="text"
                        placeholder="Search providers..."
                        value={providerSearch}
                        onChange={(e) => setProviderSearch(e.target.value)}
                        className="w-full text-sm py-1 px-2 border rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none"
                        onClick={(e) => e.stopPropagation()}
                        autoFocus
                      />
                    </div>
                    <div
                      className="max-h-52 overflow-y-auto"
                      style={{ maxHeight: "400px" }}
                    >
                      {filteredProviders?.length === 0 ? (
                        <div className="px-3 py-2 text-gray-500 text-sm">
                          No providers found
                        </div>
                      ) : (
                        filteredProviders?.map((provider) => (
                          <div
                            key={provider.id}
                            className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm text-gray-700 transition-colors"
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedProviderId(provider.id);
                              setIsProviderOpen(false);
                              setProviderSearch("");
                            }}
                          >
                            {provider.name}
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Course Dropdown */}
              <div className="flex-1 min-w-[180px] relative course-dropdown">
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  Course / Visa
                </label>
                <div
                  className="w-full text-sm py-2 px-3 border border-gray-300 rounded-md cursor-pointer bg-white focus-within:ring-1 focus-within:ring-blue-500"
                  onClick={() => setIsCourseOpen(!isCourseOpen)}
                >
                  <span className="truncate text-gray-800 block overflow-hidden text-ellipsis">
                    {selectedCourseId
                      ? coursesList.find((c) => c.id == selectedCourseId)
                          ?.name || "— Select —"
                      : "— Select —"}
                  </span>
                </div>

                {isCourseOpen && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
                    <div className="p-2 border-b">
                      <input
                        type="text"
                        placeholder="Search courses..."
                        value={courseSearch}
                        onChange={(e) => setCourseSearch(e.target.value)}
                        className="w-full text-sm py-1 px-2 border rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none"
                        onClick={(e) => e.stopPropagation()}
                        autoFocus
                      />
                    </div>
                    <div
                      className="max-h-52 overflow-y-auto"
                      style={{ maxHeight: "400px" }}
                    >
                      {filteredCourses?.length === 0 ? (
                        <div className="px-3 py-2 text-gray-500 text-sm">
                          No courses found
                        </div>
                      ) : (
                        filteredCourses?.map((course) => (
                          <div
                            key={course.id}
                            className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm text-gray-700 transition-colors"
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedCourseId(course.id);
                              setIsCourseOpen(false);
                              setCourseSearch("");
                            }}
                          >
                            {course.name}
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Checklist Categories Dropdown */}
              <div className="flex-1 min-w-[180px] relative checklist-dropdown">
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  CheckList Categories
                </label>
                <div
                  className="w-full text-sm py-2 px-3 border border-gray-300 rounded-md cursor-pointer bg-white focus-within:ring-1 focus-within:ring-blue-500"
                  onClick={() => setIsCheckListOpen(!isCehckListOpen)}
                >
                  <span className="truncate text-gray-800 block overflow-hidden text-ellipsis">
                    {selectedChecklistCategory
                      ? allCheckListCategories.find(
                          (c) => c.id == selectedChecklistCategory
                        )?.name || "— Select —"
                      : "— Select —"}
                  </span>
                </div>

                {isCehckListOpen && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
                    <div className="p-2 border-b">
                      <input
                        type="text"
                        placeholder="Search categories..."
                        value={checklistSearch}
                        onChange={(e) => setChecklistSearch(e.target.value)}
                        className="w-full text-sm py-1 px-2 border rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none"
                        onClick={(e) => e.stopPropagation()}
                        autoFocus
                      />
                    </div>
                    <div
                      className="max-h-52 overflow-y-auto"
                      style={{ maxHeight: "400px" }}
                    >
                      {filteredChecklistCategories?.length === 0 ? (
                        <div className="px-3 py-2 text-gray-500 text-sm">
                          No checklist categories found
                        </div>
                      ) : (
                        filteredChecklistCategories?.map((cat) => (
                          <div
                            key={cat.id}
                            className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm text-gray-700 transition-colors"
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedChecklistCategory(cat.id);
                              setIsCheckListOpen(false);
                              setChecklistSearch("");
                            }}
                          >
                            {cat.name}
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="flex items-center justify-end gap-2">
              <div>
                <Button
                  text="Clear All"
                  variant="outline"
                  size="sm"
                  onClick={() => {
                    setFilterKey((prev) => prev + 1);
                    setSelectedCategory("");
                    setSelectedProviderId("");
                    setSelectedCourseId("");
                    setProviderSearch("");
                    setCourseSearch("");
                    setIsProviderOpen(false);
                    setIsCourseOpen(false);
                    setSelectedChecklistCategory("");
                    setSelectedRows([]);
                  }}
                />
              </div>
              <div>
                <Button
                  text="Apply Filter"
                  variant="primary"
                  size="sm"
                  onClick={() => {
                    setPagination((prev) => ({ ...prev, currentPage: 1 }));
                    setFilterKey((prev) => prev + 1);
                  }}
                />
              </div>
            </div>
          </div>

          {/* table */}
          <table className="table w-full">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    className="w-6 h-6 accent-blue-600 cursor-pointer"
                    checked={
                      list?.length > 0 && selectedRows.length === list?.length
                    }
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedRows(list?.map((item) => item.id));
                      } else {
                        setSelectedRows([]);
                      }
                    }}
                  />
                </th>
                <th>Provider</th>
                <th>course / Visa</th>
                <th>CheckList Category</th>
                <th>CheckList</th>
                <th>Applicant</th>
                <th className="text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {showSkeleton ? (
                <>
                  {[...Array(3)].map((_, i) => (
                    <tr key={i}>
                      {/* Category Name */}
                      <td className="py-3">
                        <div className="h-5 w-32 bg-gray-300 rounded animate-pulse"></div>
                      </td>
                      <td className="py-3">
                        <div className="flex items-center gap-2">
                          <div className="h-4 w-20 bg-gray-300 rounded animate-pulse"></div>
                        </div>
                      </td>
                      {/* Created By */}
                      <td className="py-3">
                        <div className="flex items-center gap-2">
                          <div className="h-4 w-20 bg-gray-300 rounded animate-pulse"></div>
                        </div>
                      </td>
                      <td className="py-3">
                        <div className="flex items-center gap-2">
                          <div className="h-4 w-20 bg-gray-300 rounded animate-pulse"></div>
                        </div>
                      </td>
                      {/* Created At */}
                      <td className="py-3">
                        <div className="flex items-center gap-2">
                          <div className="h-4 w-24 bg-gray-300 rounded animate-pulse"></div>
                        </div>
                      </td>
                      {/* Actions */}
                      <td className="py-3 text-right pr-6">
                        <div className="flex justify-end gap-2">
                          {/* <div className="h-8 w-16 bg-gray-300 rounded animate-pulse"></div> */}
                          <div className="h-8 w-16 bg-gray-300 rounded animate-pulse"></div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </>
              ) : list?.length === 0 ? (
                <tr>
                  <td
                    colSpan={12}
                    className="text-center py-6 text-base-content/60"
                  >
                    No Data found.
                  </td>
                </tr>
              ) : (
                list?.map((item, index) => (
                  <tr key={index}>
                    <td className="align-middle">
                      <input
                        type="checkbox"
                        className="w-6 h-6 accent-blue-600 cursor-pointer"
                        checked={selectedRows.includes(item.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedRows((prev) => [...prev, item.id]);
                          } else {
                            setSelectedRows((prev) =>
                              prev.filter((id) => id !== item.id)
                            );
                          }
                        }}
                      />
                    </td>
                    <td className="align-middle">{item?.provider?.name}</td>
                    <td className="align-middle">{item?.course?.name}</td>
                    <td className="align-middle">
                      {item?.checklistCategory?.name}
                    </td>
                    <td className="align-middle">{item?.checklist?.title}</td>
                    <td className="align-middle">
                      {item?.applicant_type?.name}
                    </td>
                    <td className="align-middle">
                      <div className="flex justify-end gap-2">
                        {/* <Button
                          text="Edit"
                          variant="primary"
                          size="sm"
                          onClick={() =>
                            navigate("/checklist/attach/to-provider", {
                              state: { assignment: item },
                            })
                          }
                        ></Button> */}
                        <Button
                          text="Delete"
                          variant="danger"
                          size="sm"
                          onClick={() => handleDelete(item?.id)}
                          isDisabled={loading}
                        ></Button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {selectedRows?.length > 1 && (
            <div className="w-32 flex justify-end items-end mt-3">
              <Button
                text="Delete All"
                variant="danger"
                size="sm"
                onClick={() => handleDeleteBulk()}
              />
            </div>
          )}
          {/* pagiantion */}
          <div className="row align-items-center mb-5 mt-2">
            <div className="col-auto">
              <select
                value={pagination?.perPage}
                onChange={handlePerPageChange}
                className="form-select"
                style={{ minWidth: 80 }}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
              </select>
            </div>
            <div className="col-auto text-muted">
              Page {pagination.currentPage} – Showing{" "}
              {Math.min(
                pagination.perPage,
                pagination.total -
                  (pagination.currentPage - 1) * pagination.perPage
              )}{" "}
              of {pagination.total} entries
            </div>
            <div className="col">
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                breakLabel={"..."}
                pageCount={pagination.lastPage}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageChange}
                forcePage={pagination.currentPage - 1}
                containerClassName={"pagination justify-content-end mb-0"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                activeClassName={"active"}
                disabledClassName={"disabled"}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ChecklistToProviders;
